import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-deleted-success',
  templateUrl: './user-deleted-success.component.html',
  styleUrls: ['./user-deleted-success.component.css']
})
export class UserDeletedSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
